import React from 'react';
import { BoardState } from '@v2/pages/planboard/components/Board/web/types';
import { Column } from '@v2/pages/planboard/components/Board/web/Column';

const Columns = ({ boardData }: { boardData: BoardState }) => {
  return boardData.orderedColumnIds.map((columnId) => {
    return <Column column={boardData.columnMap[columnId]} key={columnId} />;
  });
};

export default Columns;
